import React from "react";

import { ILeadId } from "../../Lead.props";
import EditLead from "./EditLead";

const EditLeadIndex: React.FC<ILeadId> = ({ leadId, setMethod }) => {
  return <EditLead leadId={leadId} setMethod={setMethod} />;
};

export default EditLeadIndex;
